/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var UIUtil = require('psa-core/util/ui');

var SelectFieldView = require('common/views/SelectFieldView');

var TimeTrkOpenObjectSelectionModalView = require('../../common/views/TimeTrkOpenObjectSelectionModalView');
var TimeTrkHoursFormView = require('../../common/views/TimeTrkHoursFormView');

require('../styles/TimeTrkDepEntryRowView.css');
var tmplTimeTrkDepEntryRowView = require('../templates/TimeTrkDepEntryRowView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplTimeTrkDepEntryRowView,

  className: 'time-trk-dep-entry-row-view panel panel-default',

  ui: {
    entityCategorySelect: '.entity-category-select',
    timeCategorySelect: '.time-category-select',
    btnObjectSelection: '.btn-object-selection',
    selectedObjectName: '.selected-object-name',
    objectSelection: '.object-selection',
    btnClearObject: '.btn-clear-object',
    hoursContainer: '.hours-container',
    removeEntry: '.remove-entry'
  },

  regions: {
    timeCategorySelect: '@ui.timeCategorySelect',
    hoursContainer: '@ui.hoursContainer'
  },

  triggers: {
    'click @ui.removeEntry': 'remove:entry'
  },

  events: {
    'change @ui.entityCategorySelect': 'onChangeEntityCategory',
    'click @ui.btnObjectSelection': 'onClickObjectSelection',
    'click @ui.btnClearObject': 'onClickClearObject'
  },

  childEvents: {
    'update:time-entries': 'onUpdateTimeEntries'
  },

  templateHelpers: function() {
    return {
      childIndex: this.options.childIndex + 1,
      categories: this.options.categories,
      worksites: this.options.worksites,
      entityCategories: this.options.entityCategories
    };
  },

  onBeforeShow: function() {
    var categories = this.options.categories;
    var categoryId = this.model.get('categoryId');

    if (categoryId) {
      var entityTypeId = _.findWhere(categories, { id: categoryId }).depEntityCategoryId;
      this.model.set('entityTypeId', entityTypeId);
    }

    var worksiteId = this.model.get('worksiteId');
    if (worksiteId === null || typeof worksiteId === 'undefined') { 
      this.model.set('worksiteId','2');
    }

    this.timeCategorySelect = new SelectFieldView({
      isDisabled: false,
      isRequired: true,
      name: 'categoryId',
      collection: new Backbone.Collection([])
    });

    Syphon.deserialize(this, this.model.toJSON());

    this.showChildView('timeCategorySelect', this.timeCategorySelect);
    this.onChangeEntityCategory();
    
    this.timeCategorySelect.setValue(categoryId);

    this.showChildView('hoursContainer', new TimeTrkHoursFormView({ options: this.options, model: this.model }));

    this.objectId = this.model.get('objectId');
  },

  onChangeEntityCategory: function() {
    var entityCategoryId = this.ui.entityCategorySelect.val();
    var allTimeCategories = this.options.categories;

    this.timeCategorySelect.collection.reset(
      _.chain(allTimeCategories)
        .where({ depEntityCategoryId: entityCategoryId })
        .map(function(filteredTimeCategories) {
          return { value: filteredTimeCategories.id, text: filteredTimeCategories.category };
        })
        .value()
    );
  },

  onUpdateTimeEntries: function(childView) {
    this.model.set('timeEntries', childView.model.get('timeEntries'));
    this.triggerMethod('update:hour-totals'); // TimeTrkDepExaminerEntryView
  },

  onClickObjectSelection: function(e) {
    e.preventDefault();
    var self = this;
    var timesheet = this.options.timesheet || {};
    var departmentId = timesheet.departmentId;
    var objects = timesheet.dpOpenExams;
      UIUtil.showModal({
        title: 'Select Exam',
        dialogClasses: 'modal-dialog-time-trk-object-selection-modal-view',
        view: new TimeTrkOpenObjectSelectionModalView({
          model: new Backbone.Model({
            objectId: this.objectId,
            departmentId: departmentId,
            objects: objects
          })
        }) 
      }).done(function(object) {
        if (object) {
          self.objectId = object.objectId;
          var objectDisplayName = _.findWhere(objects, { objectId: object.objectId }).objectDisplayName;
          self.ui.selectedObjectName.val(objectDisplayName);
        } else {
          self.objectId = '';
          self.ui.selectedObjectName.val('');
        }
      });
  
  },

  onClickClearObject: function(e) {
    e.preventDefault();
    this.objectId = '';
    this.ui.selectedObjectName.val('');
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.objectTypeId = 'EXAM';
    formData.objectId = this.objectId;
    return formData;
  }
});
